import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import axios from 'axios';
import appHistory from '@/utils/history';
import { isSSR } from '@/utils/is';
import { storageGetItem, storageSetItem } from '../storage';
import { openConfirm } from '../confirm';
function getLocalStorageValue(key) {
  if (isSSR) {
    return null;
  }
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}
function redirectToLogin() {
  if (isSSR) {
    return;
  }
  const current = appHistory.location.pathname.replace(/\//g, '');
  if (current === 'login') {
    return;
  }
  window.localStorage.removeItem('user');
  window.localStorage.removeItem('token');
  appHistory.replace('/login');
}
function getMsgFromBody(data) {
  if (!data || typeof data !== 'object') {
    return undefined;
  }
  if ('msg' in data && typeof data.msg === 'string') {
    return data.msg;
  }
  if ('message' in data && typeof data.message === 'string') {
    return data.message;
  }
  return undefined;
}
function getHttpStatusMessage(status) {
  if (!status) {
    return undefined;
  }
  if (status === 400) return '请求参数错误';
  if (status === 401) return '登录已过期，请重新登录';
  if (status === 403) return '没有权限访问';
  if (status === 404) return '接口不存在';
  if (status === 408) return '请求超时，请稍后重试';
  if (status === 429) return '请求过于频繁，请稍后再试';
  if (status === 500) return '服务器异常，请稍后重试';
  if (status === 502) return '网关错误，请稍后重试';
  if (status === 503) return '服务不可用，请稍后重试';
  if (status === 504) return '网关超时，请检查后端服务是否正常';
  return `请求失败(${status})`;
}
function wrapRequestError(original, message) {
  const error = new Error(message);
  error.cause = original;
  return error;
}
const request = axios.create({
  timeout: 15000,
  withCredentials: true
});
request.interceptors.request.use(config => {
  const nextConfig = {
    ...config
  };
  nextConfig.headers = nextConfig.headers || {};
  const lang = getLocalStorageValue('arco-lang');
  if (lang) {
    nextConfig.headers['Accept-Language'] = lang;
  }
  const token = storageGetItem('token');
  if (token) {
    nextConfig.headers.Authorization = `Bearer ${token}`;
  }
  return nextConfig;
});
request.interceptors.response.use(response => {
  const data = response.data;
  const newToken = response.headers['x-refreshed-token'];
  if (newToken) {
    console.log('--------------------------->newToken', newToken);
    storageSetItem('token', newToken);
  }
  if (typeof response.status === 'number' && ![200, 201].includes(response.status)) {
    const msg = getMsgFromBody(data) || getHttpStatusMessage(response.status) || `请求失败(${response.status})`;
    _Message.error(msg);
    return Promise.reject(new Error(msg));
  }
  if (data && typeof data === 'object' && 'code' in data) {
    const codeData = data;
    if (typeof codeData.code === 'number' && codeData.code !== 200) {
      const msg = codeData.msg || codeData.message || `请求失败(${codeData.code})`;
      _Message.error(msg);
      return Promise.reject(new Error(msg));
    }
  }
  if (data && typeof data === 'object' && 'status' in data) {
    const statusData = data;
    if (statusData.status === 'error') {
      const msg = statusData.msg || '请求失败';
      _Message.error(msg);
      return Promise.reject(new Error(msg));
    }
  }
  return response.data;
}, error => {
  const status = error.response?.status;
  if (status === 401) {
    const message = getMsgFromBody(error.response?.data) || getHttpStatusMessage(status) || '登录已过期，请重新登录';
    openConfirm({
      id: '401',
      title: '登出',
      content: `登录已过期，请重新登录`,
      onOk: () => {
        redirectToLogin();
        // Message.error(message);
      }
    });
    return Promise.reject(wrapRequestError(error, message));
  }
  const bodyMessage = getMsgFromBody(error.response?.data);
  const isTimeout = error.code === 'ECONNABORTED' || String(error.message || '').toLowerCase().includes('timeout');
  const message = bodyMessage ? bodyMessage : isTimeout ? '请求超时，请稍后重试' : getHttpStatusMessage(status) || '网络异常，请检查网络连接';
  _Message.error(message);
  return Promise.reject(wrapRequestError(error, message));
});
export default request;